export const MERCH_PRODUCT_CONFIG = {
    mug: {
        asset: "https://cdn.builder.io/api/v1/image/assets%2F5c32841cdfc646708f6dc9b494dadddc%2F59b5537be1b54d7e8813cfc9cec043b6",
        imageArea: { left: 6, top: 10.5, width: 66.5, height: 97, rotation: 0, scale: 1, skew: 0 },
        transformType: "curve",
        curveStrength: 0.25,
        curvePower: 2,
        verticalPadding: 50,
    },
    video: { transformType: "none", displayType: "image" },
    tabletop: {
        asset: "https://cdn.builder.io/api/v1/image/assets%2F5c32841cdfc646708f6dc9b494dadddc%2F251d66f1e1194a7fb9841b8372df8001",
        imageArea: { left: 9.7, top: 19.3, width: 80, height: 62.9, rotation: 0, scale: 1, skew: 0 },
        transformType: "none",
    },
    puzzle: {
        asset: "https://via.placeholder.com/400x400?text=Preview",
        imageArea: { left: 12.5, top: 12.5, width: 75, height: 75, rotation: 0, scale: 1, skew: 0 },
        transformType: "none",
    },
    canvas: {
        asset: "https://cdn.builder.io/api/v1/image/assets%2F5c32841cdfc646708f6dc9b494dadddc%2F20eb87608f5f4d0ea12109137c6972d2",
        imageArea: { left: 8.4, top: 6.7, width: 83.3, height: 86.4, rotation: 0, scale: 1, skew: 0 },
        transformType: "none",
    },
    poster: {
        asset: "https://via.placeholder.com/400x400?text=Preview",
        imageArea: { left: 2.5, top: 2.5, width: 95, height: 95, rotation: 0, scale: 1, skew: 0 },
        transformType: "none",
    },
    song: { transformType: "text", displayType: "lyrics" },
    "love-story-map": {
        transformType: "none",
        displayType: "image",
        previewLayout: "portrait",
    },
};

const clone = (value) => JSON.parse(JSON.stringify(value));

export const getMerchProductConfig = (productType) => {
    const aliases = {
        love_story_map: "love-story-map",
        loveStoryMap: "love-story-map",
        lovestorymap: "love-story-map",
    };
    const configKey = aliases[productType] || productType;
    return clone(MERCH_PRODUCT_CONFIG[configKey] || MERCH_PRODUCT_CONFIG.mug);
};

const transformCurve = (img, canvas, config) => {
    const originalW = img.width;
    const originalH = img.height;
    const curveStrength = config.curveStrength || 0;
    const curvePower = config.curvePower || 1;
    const verticalPadding = config.verticalPadding || 0;
    const maxOffset = originalH * curveStrength;
    const canvasH = originalH + Math.abs(maxOffset) + (verticalPadding * 2);
    canvas.width = originalW;
    canvas.height = canvasH;
    const context = canvas.getContext("2d");
    context.clearRect(0, 0, originalW, canvasH);

    for (let x = 0; x < originalW; x++) {
        const relativeX = (x / (originalW - 1) - 0.5) * 2;
        const offset = curveStrength * maxOffset * (1 - Math.pow(Math.abs(relativeX), curvePower));
        const finalY = verticalPadding + offset;
        if (finalY >= 0 && finalY + originalH <= canvasH) {
            context.drawImage(img, x, 0, 1, originalH, x, finalY, 1, originalH);
        }
    }
};

const transformNone = (img, canvas) => {
    canvas.width = img.width;
    canvas.height = img.height;
    const context = canvas.getContext("2d");
    context.clearRect(0, 0, canvas.width, canvas.height);
    context.drawImage(img, 0, 0);
};

const DROPBOX_SHARE_HOSTS = new Set(["www.dropbox.com", "dropbox.com"]);

// Dropbox share links answer with a redirect that carries no CORS headers, so a
// crossOrigin image load fails before it reaches the file. The content host serves
// the same file with Access-Control-Allow-Origin: *, which canvas processing needs.
export const toCorsImageUrl = (url) => {
    try {
        const parsed = new URL(url);
        if (!DROPBOX_SHARE_HOSTS.has(parsed.hostname)) return url;
        parsed.hostname = "dl.dropboxusercontent.com";
        return parsed.toString();
    } catch (_error) {
        // sentry-ignore: unparsable URL is loaded unchanged
        return url;
    }
};

export const getImageHost = (url) => {
    try {
        return new URL(url).hostname || "unknown";
    } catch (_error) {
        // sentry-ignore: unparsable URL only affects a diagnostic tag
        return "invalid";
    }
};

export const processMerchImage = ({ srcUrl, canvas, config, onFallback }) => new Promise((resolve) => {
    if (!canvas) {
        resolve(srcUrl);
        return;
    }

    // The original URL still renders as a plain <img>, just without the product transform.
    const fallback = (reason) => {
        if (onFallback) onFallback(reason);
        resolve(srcUrl);
    };

    const image = new window.Image();
    image.crossOrigin = "anonymous";
    image.onload = () => {
        try {
            if (config.transformType === "curve") {
                transformCurve(image, canvas, config);
            } else {
                transformNone(image, canvas);
            }
            resolve(canvas.toDataURL("image/png"));
        } catch (_error) {
            // sentry-ignore: reported by the caller via onFallback
            fallback("canvas_error");
        }
    };
    // sentry-ignore: reported by the caller via onFallback
    image.onerror = () => fallback("image_load_error");
    image.src = toCorsImageUrl(srcUrl);
});
